// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import SocialMediaItem from "./SocialMediaItem";

// Data / Images / Icons
import { SOCIAL_MEDIA_NAV } from "src/data/nav/social_media_nav";

function SocialMediaItemGroup() {
  return (
    <div className="flex space-x-6 mb-4">
      {SOCIAL_MEDIA_NAV.map((item, idx) => {
        return <SocialMediaItem key={idx} link={item.link} icon={item.icon} />;
      })}
    </div>
  );
}

export default SocialMediaItemGroup;
